export const SEND_MESSAGE = "Help/SEND_MESSAGE";
export const SEND_MESSAGE_SUCCESS = "Help/SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_ERROR = "Help/SEND_MESSAGE_ERROR";

export const REDUCER_NAME = "help";
